import React from "react";

export const VaporizerIcon = () => {
  return (
    <svg
      width="40"
      height="27"
      viewBox="0 0 40 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.7381 16.2304C19.4913 18.6207 20.2603 21.6663 19.7989 24.7119L19.4606 26.9865H25.3354L25.5199 25.3287C26.1659 20.0857 24.6895 14.8811 21.5214 11.0259L21.3061 10.756C19.5529 8.36581 18.7839 5.32019 19.2453 2.27457L19.5221 0H13.7088L13.5242 1.65774C12.9091 6.90083 14.3547 12.1054 17.5228 15.9991L17.7381 16.2304Z" />
      <path d="M31.1235 16.2304C32.8767 18.6207 33.6457 21.6663 33.1843 24.7119L32.846 26.9865H38.7208L38.9053 25.3287C39.5512 20.0857 38.0748 14.8811 34.9068 11.0259L34.6914 10.756C32.9382 8.36581 32.1693 5.32019 32.6306 2.27457L32.9075 0H27.0942L26.9096 1.65774C26.2945 6.90083 27.7401 12.1054 30.9082 15.9991L31.1235 16.2304Z" />
      <path d="M4.35274 16.2304C6.10596 18.6207 6.87492 21.6663 6.41354 24.7119L6.0752 26.9865H11.95L12.1346 25.3287C12.7805 20.0857 11.3041 14.8811 8.136 11.0259L7.92069 10.756C6.16748 8.36581 5.39852 5.32019 5.85989 2.27457L6.13672 0H0.323422L0.138869 1.65774C-0.476295 6.90083 0.969343 12.1054 4.13744 15.9991L4.35274 16.2304Z" />
    </svg>
  );
};
